export const impact = {
  async impactAssessments() {
    let data = { data: [] };
    try { data = await API.getImpactAssessments(); } catch (e) { /* empty */ }

    return `
      <div class="page-header">
        <div><h2>Algorithmic Impact Assessments</h2><p>Bias testing, fairness evaluation, and drift detection</p></div>
        <button class="btn btn-primary" id="btn-add-aia">+ New Impact Assessment</button>
      </div>
      <div class="card">
        <div class="table-container">
          <table>
            <thead><tr><th>AI System</th><th>Period</th><th>Drift Detected</th><th>Remediation</th><th>Status</th><th>Assessor</th></tr></thead>
            <tbody>
              ${data.data.length > 0 ? data.data.map(ia => `
                <tr>
                  <td><strong>${ia.asset_name}</strong></td>
                  <td>${ia.assessment_period || 'N/A'}</td>
                  <td>${ia.drift_detected ? '<span class="badge badge-critical">Yes</span>' : '<span class="badge badge-low">No</span>'}</td>
                  <td>${ia.remediation_required ? App.badge(ia.remediation_status || 'planned') : 'Not needed'}</td>
                  <td>${App.badge(ia.status)}</td>
                  <td>${ia.assessor_name}</td>
                </tr>
              `).join('') : '<tr><td colspan="6" class="empty-state">No impact assessments yet</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  },

  async showImpactForm() {
    let assets = [];
    try { assets = (await API.getAssets()).data || []; } catch { /* empty */ }
    if (!assets.length) {
      App.openModal('New Algorithmic Impact Assessment',
        `<div class="empty-state"><p>You need to register at least one AI system before running an impact assessment.</p><button class="btn btn-primary" data-goto-assets>Go to AI Asset Registry</button></div>`,
        '<button class="btn btn-outline" data-modal-close>Close</button>');
      document.querySelectorAll('[data-modal-close]').forEach(b => b.addEventListener('click', () => App.closeModal()));
      document.querySelectorAll('[data-goto-assets]').forEach(b => b.addEventListener('click', () => { App.closeModal(); App.navigate('ai-assets'); }));
      return;
    }
    const assetOptions = assets.map(a =>
      `<option value="${a.id}">${a.name}${a.version ? ' v' + a.version : ''} — ${a.risk_tier} risk${a.phi_access ? ' · PHI' : ''}</option>`
    ).join('');

    App.openModal('New Algorithmic Impact Assessment', `
      <form id="aia-form">
        <div class="form-group"><label>AI System <span class="required">*</span></label>
          <select id="ia-asset" required>
            <option value="">Select an AI system…</option>
            ${assetOptions}
          </select>
        </div>
        <div class="form-group"><label>Assessment period</label><input type="text" id="ia-period" placeholder="e.g., Q1 2026"></div>
        <div class="form-group"><label>Demographic groups tested</label>
          <textarea id="ia-groups" placeholder="Comma-separated, e.g., race, ethnicity, gender, age, socioeconomic status"></textarea>
        </div>
        <div class="form-row">
          <div class="form-group"><label>Drift detected</label>
            <select id="ia-drift"><option value="0">No</option><option value="1">Yes</option></select>
          </div>
          <div class="form-group"><label>Remediation required</label>
            <select id="ia-remed"><option value="0">No</option><option value="1">Yes</option></select>
          </div>
        </div>
      </form>
    `, '<button class="btn btn-outline" data-modal-close>Cancel</button><button class="btn btn-primary" id="ia-submit">Create assessment</button>');
    document.querySelectorAll('[data-modal-close]').forEach(b => b.addEventListener('click', () => App.closeModal()));
    document.getElementById('ia-submit').addEventListener('click', async () => {
      const assetId = document.getElementById('ia-asset').value;
      if (!assetId) { App.toast('Please select an AI system', 'error'); return; }
      try {
        const groups = document.getElementById('ia-groups').value;
        await API.createImpactAssessment({
          ai_asset_id: assetId,
          assessment_period: document.getElementById('ia-period').value || null,
          demographic_groups_tested: groups ? groups.split(',').map(g => g.trim()) : [],
          drift_detected: document.getElementById('ia-drift').value === '1',
          remediation_required: document.getElementById('ia-remed').value === '1',
        });
        App.closeModal();
        App.toast('Impact assessment created', 'success');
        App.navigate('impact-assessments');
      } catch (err) { App.toast(err.message, 'error'); }
    });
  },
};
